import {
  CreateContextProvider,
  Form,
  SaveButton,
  useCreateController,
  useNotify,
  useRefresh,
  useTranslate,
} from 'react-admin';
import { DialogTitle, DialogContent, DialogActions, Button as MUIButton } from '@mui/material';
import { agentCreateReferral } from '../../services/agentCreateReferral';
import { Resources } from '../resource';
import UpgradeAgentForm from './UpgradeAgentForm';
import CreateReferralForm from './CreateReferralForm';
import { findAgentInfoAPI } from '../../services/agentInfoService';
import * as adminConfigService from '../../services/adminConfigService';
import { PermissionButton } from 'src/routes/components/permission-button';

type Row = {
  userId: string;
  userLevel?: string;
  [key: string]: any;
};

const CreateReferral = ({
  row,
  open,
  onClose,
}: {
  row: Row;
  open?: boolean;
  onClose: () => void;
}) => {
  const notify = useNotify();
  const t = useTranslate();
  const refresh = useRefresh();

  const onSubmit = async (values: any) => {
    const referredUserId = row?.referredUserId ?? values?.referredUserId;
    if (!referredUserId) {
      notify('Missing referredUserId', { type: 'warning' });
      return;
    }
    const referrerId = row?.userId ?? values?.userId;
    if (!referrerId) {
      notify('Missing referrerId', { type: 'warning' });
      return;
    }
    try {
      const response = await agentCreateReferral({
        userId: referredUserId,
        referrerId: referrerId,
      });
      // console.log('=== agentCreateReferral ===', response.data);
      if (response.data.data === null && response.data.errors.length > 0) {
        notify(response.data.errors[0].message || 'module.agentInfo.FailToCreateReferral', {
          type: 'error',
        });
        return;
      }
    } catch (error) {
      console.error('Failed to fetch  agent Info:', error);
      notify(
        (error as any)?.response?.data?.message ||
          (error as any)?.message ||
          'module.agentInfo.FailToCreateReferral',
        { type: 'error' }
      );
      return;
    }
    notify('module.agentInfo.SuccessfullyCreateReferral', { type: 'success' });
    refresh();
    onClose();
  };

  if (open === false) return null;

  const defaultValues = {
    userId: row.userId,
  };

  return (
    <Form disableInvalidFormNotification defaultValues={defaultValues} onSubmit={onSubmit}>
      <DialogTitle>{t('module.agentInfo.createReferral')}</DialogTitle>

      <DialogContent>
        <CreateReferralForm />
      </DialogContent>

      <DialogActions>
        <MUIButton variant="outlined" onClick={onClose}>
          {t('actions.cancel')}
        </MUIButton>
        <PermissionButton resource="agent-info" action="create-referral">
          <SaveButton />
        </PermissionButton>
      </DialogActions>
    </Form>
  );
};

export default CreateReferral;
